import { render } from "./Widget.vue?vue&type=template&id=6c92feea&scoped=true"
import script from "./Widget.vue?vue&type=script&lang=ts"
export * from "./Widget.vue?vue&type=script&lang=ts"

import "./Widget.vue?vue&type=style&index=0&id=6c92feea&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6c92feea"

export default script